import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Light() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img src="/service/Streetlighting.png" alt="" />

          <div className="hero-content">
            <h1>STREET LIGHTING</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">STREET LIGHTING</h2>

          <p>
            As our country is progressing, there is a necessity for illuminating
            streets, roads and highways for better movement and security of
            traffic and personnel. Illumination is proportionate to the
            development of a country and we are proud to have contributed our
            best with power-efficient and smart lighting solutions. With our
            commitment and proven track record, we have been a top choice for
            governments and development authorities for prompt and perfect
            execution of such projects.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}


export default Light;
